import React from 'react';
import { Link } from 'react-router';

const ActiveLink = props => (
  <Link {...props} activeClassName="active" />
);

export default ActiveLink;



// WEBPACK FOOTER //
// ./src/components/utils/active-link/index.jsx